import React, { useEffect, useState } from 'react';
import { Image } from 'react-bootstrap';
import { ChromePicker } from 'react-color';

import SelectionConfirmedIcon from '../assets/icon/selectionConfirmed.svg';
import SelectColorIcon from '../assets/icon/selectColor.svg';

interface ListColorProps {
  colors: string[];
  colorSelected: string;
  setColorSelected: (color: string) => void;
  positionShow: string;
  positionShowTop?: string;
  enable?: boolean;
  changeColor?: boolean;
  showColorSelected?: boolean;
}

const ListColor = ({
  colors,
  colorSelected,
  setColorSelected,
  positionShow,
  positionShowTop,
  enable,
  changeColor,
  showColorSelected,
}: ListColorProps): JSX.Element => {
  const [showColor, setShowColor] = useState(false);
  const [corPersonalizadaSelecionada, setCorPersonalizadaSelecionada] =
    useState(false);
  const [corPersonalizada, setCorPersonalizada] = useState('D1D1D1');

  useEffect(() => {
    if (colors.findIndex((color) => color === colorSelected) === -1) {
      setCorPersonalizadaSelecionada(true);
      setCorPersonalizada(colorSelected);
    } else {
      setCorPersonalizadaSelecionada(false);
    }
  }, [colorSelected]);

  return (
    <div className="d-flex position-relative">
      {colors.map((color) => (
        <div className="position-relative" key={color}>
          {colorSelected === color && (
            <Image
              src={SelectionConfirmedIcon}
              alt="Cor Selecionada"
              className="position-absolute"
              style={{
                width: '1.2rem',
                height: '1.2rem',
                marginLeft: '1.2rem',
                marginTop: '1.2rem',
              }}
            />
          )}
          <div
            role="button"
            tabIndex={0}
            aria-label="Select red color"
            style={{
              backgroundColor: color,
              marginRight: '0.7rem',
              borderRadius: '0.6875rem',
              border: '1px #828282 solid',
              width: '1.875rem',
              height: '1.875rem',
              pointerEvents: `${
                color === '#D9D9D9' || !enable ? 'none' : 'auto'
              }`,
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                setColorSelected(color);
                setCorPersonalizadaSelecionada(false);
              }
            }}
            onClick={() => {
              setColorSelected(color);
              setCorPersonalizadaSelecionada(false);
            }}
          />
        </div>
      ))}

      {showColorSelected && (
        <div
          role="button"
          tabIndex={0}
          aria-label="Select red color"
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              setCorPersonalizadaSelecionada(true);
              setColorSelected(corPersonalizada);
            }
          }}
          onClick={() => {
            setCorPersonalizadaSelecionada(true);
            setColorSelected(corPersonalizada);
          }}
        >
          {corPersonalizadaSelecionada && (
            <Image
              src={SelectionConfirmedIcon}
              alt="Cor Selecionada"
              className="position-absolute"
              style={{
                width: '1.2rem',
                height: '1.2rem',
                marginLeft: '1.2rem',
                marginTop: '1.2rem',
              }}
            />
          )}
          <div
            aria-label="Cor Selecionada"
            style={{
              backgroundColor: corPersonalizada,
              marginRight: '0.7rem',
              borderRadius: '0.6875rem',
              border: '1px #828282 solid',
              width: '1.875rem',
              height: '1.875rem',
            }}
          />
        </div>
      )}

      {changeColor && (
        <div
          role="button"
          tabIndex={0}
          aria-label="Select red color"
          onClick={() => setShowColor(!showColor)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') setShowColor(!showColor);
          }}
          style={{ width: '31px', height: '30px', position: 'relative' }}
        >
          <Image
            src={SelectColorIcon}
            style={{ width: '1.875rem', height: '1.875rem' }}
            alt="Cor Selecionada"
          />
        </div>
      )}

      {/* Exibe a paleta de cores para o usuário */}
      <div
        className={`position-absolute ${showColor ? 'd-block' : 'd-none'}`}
        style={{
          top: `${positionShowTop}`,
          left: `${positionShow}`,
          zIndex: 2,
        }}
      >
        <ChromePicker
          color={colorSelected === null ? '#616161' : colorSelected}
          onChange={(color) => {
            setColorSelected(color.hex);
            setCorPersonalizada(color.hex);
            setCorPersonalizadaSelecionada(true);
          }}
        />
      </div>

      {/* Fecha a paleta de cores quando clicado fora do componente */}
      <div
        className={`${showColor ? 'd-block' : 'd-none'}`}
        onClick={() => setShowColor(!showColor)}
        onKeyDown={() => setShowColor(!showColor)}
        role="button"
        style={{
          top: '0',
          left: '0',
          position: 'fixed',
          height: '100vh',
          width: '100vw',
          zIndex: 1,
        }}
        tabIndex={0}
      >
        {' '}
      </div>
    </div>
  );
};

ListColor.defaultProps = {
  enable: true,
  changeColor: true,
  positionShowTop: '2.2rem',
  showColorSelected: false,
};

export default ListColor;
